import * as types from './types'
import {
  GETWorkorderActivitiesResponse,
  GETWorkorderActivityResponse,
  POSTWorkorderActivityBody,
  POSTWorkorderActivityResponse,
  PUTWorkorderActivityBody,
  PUTWorkorderActivityResponse
} from '@cbgms/api'
import { IPaginatedRequest } from '@cbgms/api/request'
import { AsyncAction } from '@cbgms/base/redux/async-action'

export const loadWorkorderActivitiesList = (params: IPaginatedRequest = {}) =>
  AsyncAction<GETWorkorderActivitiesResponse>({
    type: [types.LOAD_WORKORDERACTIVITIES_LIST, types.LOAD_WORKORDERACTIVITIES_LIST_SUCCESS, types.LOAD_WORKORDERACTIVITIES_LIST_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: '/modules/workorder-activities',
        params
      }
    }
  })

export const loadWorkorderActivity = (UUID: string) =>
  AsyncAction<GETWorkorderActivityResponse>({
    type: [types.LOAD_WORKORDERACTIVITY, types.LOAD_WORKORDERACTIVITY_SUCCESS, types.LOAD_WORKORDERACTIVITY_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: `/modules/workorder-activities/${UUID}`
      }
    }
  })

export const createWorkorderActivity = (data: POSTWorkorderActivityBody) =>
  AsyncAction<POSTWorkorderActivityResponse>({
    type: [types.CREATE_WORKORDERACTIVITY, types.CREATE_WORKORDERACTIVITY_SUCCESS, types.CREATE_WORKORDERACTIVITY_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'POST',
        url: '/modules/workorder-activities',
        data
      }
    }
  })

export const updateWorkorderActivity = (workorderActivityUUID: string, data: PUTWorkorderActivityBody) =>
  AsyncAction<PUTWorkorderActivityResponse>({
    type: [types.UPDATE_WORKORDERACTIVITY, types.UPDATE_WORKORDERACTIVITY_SUCCESS, types.UPDATE_WORKORDERACTIVITY_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'PUT',
        url: `/modules/workorder-activities/${workorderActivityUUID}`,
        data
      }
    }
  })

export const removeWorkorderActivity = (workorderActivityUUID: string, dryRun: boolean) =>
  AsyncAction<{}>({
    type: [types.REMOVE_WORKORDERACTIVITY, types.REMOVE_WORKORDERACTIVITY_SUCCESS, types.REMOVE_WORKORDERACTIVITY_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'DELETE',
        url: `/modules/workorder-activities/${workorderActivityUUID}?dryRun=${dryRun}`
      }
    }
  })

export const resetWorkorderActivity = () => ({
  type: types.RESET_WORKORDERACTIVITY
})
